import React, { useState, useEffect } from 'react'
import '../styles/portfolio.css';
import PortfolioCard from '../components/PortfolioCard';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { portfolioProjects as projects } from '../components/data';

const Portfolio = () => {

    // const [projects, setProjects] = useState([]);

    const [error, setError] = useState();


    const [imagePopUp, setImagePopUp] = useState(false)
    const [image, setImage] = useState()

    const selectImage = (image) => {
        setImagePopUp(true)
        setImage(image)
    }



    const closeImagePopUp = () => {
        setImagePopUp(false)
        setImage()
    }





    // const API = process.env.REACT_APP_API_URL;



    // useEffect(() => {
    //     const fetchProjects = async () => {
    //         try {
    //             const { data } = await axios.get(`${API}/api/projects`);
    //             setProjects(data);
    //         } catch (err) {
    //             console.error('Error fetching projects:', err);
    //             setError('Failed to load projects.');
    //         }
    //     };

    //     fetchProjects();
    // }, []);



    useEffect(() => {
        if (imagePopUp) {

            document.body.style.overflow = 'hidden';

        } else {

            document.body.style.overflow = '';

        }

        return () => {
            document.body.style.overflow = '';

        };
    }, [imagePopUp]);

    return (
        <div id='portfolio-main' className={`${imagePopUp ? 'bg-blur' : ''}`}>
            <Helmet>
                <title>Home</title>
                <meta property="og:title" content="Alpha Builders Seattle Home Remodeling Experts" />
                <meta name="description" content="Alpha Builders Seattle's trusted home remodeler, delivering expert renovations with quality craftsmanship and personalized service. Transform your space today!" />
                <meta name="keywords" content="alpha builders, home remodeling, kitchen remodeling, flooring services, roofing services, " />
                <meta property="og:image" content="/favicon.ico" />
                <meta property="og:url" content="https://alphabuilders-wa.com/portfolio" />
                <meta property="og:type" content="website" />
            </Helmet>
            {/* <header id='portfolio-header' style={{ backgroundImage: `url('images/portfolio-head.jpg')` }}>
                <h1>OUR WORK</h1>
                </header> */}
            <header id='portfolio-header' >
                <h1>OUR WORK</h1>
                <img className='header-icon' src='images/portfolio-work-icon.png' />
            </header>
            <div className='brass-gradient' style={{ width: '100%', height: '3px' }}></div>



            <div className={`${imagePopUp ? 'image-popup' : 'closed-img-popup'}`}>
                <div onClick={closeImagePopUp} className='img-pop-x'>
                    <svg id='x-btn'
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="40"
                        height="40"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </div>

                <img src={`${image}`} />
            </div>

            <div id='portfolio-cards'>
                {projects.map((project) => {
                    return <PortfolioCard
                        key={project._id}
                        title={project.title}
                        location={project.location}
                        imageUrl={project.imageUrl}
                        description={project.description}
                        selectImage={selectImage}
                    />
                })}

            </div>

        </div>
    )
}

export default Portfolio